import LearnVisualFrame from "./LearnVisualFrame";
import p from "./visualPalette";

export default function ReserveConfidenceVisual({ title, takeaway, caption }) {
  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption} size="compact">
      <svg viewBox="0 0 700 250" role="img" aria-label="Probable and Proven are mineral reserve classifications with increasing confidence in the reserve estimate.">
        <text x="350" y="42" textAnchor="middle" fontSize="15" fontWeight="900" fill={p.ink}>Mineral Reserves</text>
        <rect x="116" y="78" width="160" height="58" rx="8" fill="#fff" stroke={p.line} />
        <text x="196" y="112" textAnchor="middle" fontSize="17" fontWeight="900" fill={p.ink}>Probable</text>
        <rect x="424" y="78" width="160" height="58" rx="8" fill={p.goldWash} stroke={p.gold} />
        <text x="504" y="112" textAnchor="middle" fontSize="17" fontWeight="900" fill={p.ink}>Proven</text>
        <line x1="278" y1="108" x2="422" y2="108" stroke={p.gold} strokeWidth="3" />
        <path d="M422 108 l-10 -7 v14 z" fill={p.gold} />
        <text x="350" y="150" textAnchor="middle" fontSize="12" fontWeight="850" fill={p.muted}>increasing confidence in reserve estimate</text>
        <rect x="76" y="172" width="548" height="52" rx="10" fill="rgba(34,35,37,0.04)" stroke={p.softLine} />
        <text x="350" y="194" textAnchor="middle" fontSize="13" fontWeight="850" fill={p.ink}>Economically mineable material supported by</text>
        <text x="350" y="212" textAnchor="middle" fontSize="13" fontWeight="850" fill={p.ink}>evaluation and modifying factors</text>
      </svg>
    </LearnVisualFrame>
  );
}
